import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/ui/Navbar';
import Footer from './components/ui/Footer';
import LandingPage from './views/LandingPage';
import { LanguageProvider } from './context/LanguageContext';
import AOS from 'aos';
import 'aos/dist/aos.css';
import GlobalLoader from './components/GlobalLoader';
import GlobalToast from './components/GlobalToast';

function App() {

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false,
        });
    }, []);

    return (
        <LanguageProvider>
            <Router>
                <Navbar />
                <GlobalLoader />
                <GlobalToast />
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                </Routes>
                <Footer />
            </Router>
        </LanguageProvider>
    );
}

export default App;
